export const FETCH_CONTRACTS = 'FETCH_CONTRACTS'
export const SET_CONTRACTS = 'SET_CONTRACTS'
export const ADD_CONTRACT = 'ADD_CONTRACT'
export const ADD_DOCUMENT = 'ADD_DOCUMENT'
export const FETCH_DOCUMENTS = 'FETCH_DOCUMENTS'
export const SET_DOCUMENTS = 'SET_DOCUMENTS'
export const SET_CONTRAGENT_ID = 'SET_CONTRAGENT_ID'
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT'
export const SIGN_DOCUMENT = 'SIGN_DOCUMENT'
export const SET_ACTIVE_DOCUMENT = 'SET_ACTIVE_DOCUMENT'
export const DELETE_FILE_DOCUMENT = 'DELETE_FILE_DOCUMENT'
export const UPLOAD_FILE_IMG_DOCUMENT = 'UPLOAD_FILE_IMG_DOCUMENT'
export const RENAME_DOCUMENT = 'RENAME_DOCUMENT'
export const SET_LOADING = 'SET_LOADING'
export const ADD_TYPE_CONTRACT = 'ADD_TYPE_CONTRACT'
